import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function Step1VetInfo({ formData, updateFormData, errors }) {
  const handleChange = (field, value) => {
    updateFormData({
      ...formData,
      vet_info: {
        ...formData.vet_info,
        [field]: value,
      },
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-heading font-bold text-slate-900 mb-2">
          Datos del Médico Veterinario
        </h2>
        <p className="text-slate-600">
          Por favor, complete su información profesional
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="vet-nombre" className="font-medium text-slate-700">
            Nombre completo <span className="text-red-500">*</span>
          </Label>
          <Input
            id="vet-nombre"
            data-testid="vet-nombre-input"
            placeholder="Dr. Juan Pérez"
            value={formData.vet_info.nombre}
            onChange={(e) => handleChange('nombre', e.target.value)}
            className={`h-11 ${errors.vet_nombre ? 'border-red-500' : ''}`}
          />
          {errors.vet_nombre && (
            <p className="text-sm text-red-500">{errors.vet_nombre}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="vet-clinica" className="font-medium text-slate-700">
            Clínica <span className="text-red-500">*</span>
          </Label>
          <Input
            id="vet-clinica"
            data-testid="vet-clinica-input"
            placeholder="Clínica Veterinaria Ejemplo"
            value={formData.vet_info.clinica}
            onChange={(e) => handleChange('clinica', e.target.value)}
            className={`h-11 ${errors.vet_clinica ? 'border-red-500' : ''}`}
          />
          {errors.vet_clinica && (
            <p className="text-sm text-red-500">{errors.vet_clinica}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="vet-telefono" className="font-medium text-slate-700">
            Teléfono <span className="text-red-500">*</span>
          </Label>
          <Input
            id="vet-telefono"
            data-testid="vet-telefono-input"
            type="tel"
            placeholder="+52 123 456 7890"
            value={formData.vet_info.telefono}
            onChange={(e) => handleChange('telefono', e.target.value)}
            className={`h-11 ${errors.vet_telefono ? 'border-red-500' : ''}`}
          />
          {errors.vet_telefono && (
            <p className="text-sm text-red-500">{errors.vet_telefono}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="vet-email" className="font-medium text-slate-700">
            Email <span className="text-red-500">*</span>
          </Label>
          <Input
            id="vet-email"
            data-testid="vet-email-input"
            type="email"
            placeholder="doctor@ejemplo.com"
            value={formData.vet_info.email}
            onChange={(e) => handleChange('email', e.target.value)}
            className={`h-11 ${errors.vet_email ? 'border-red-500' : ''}`}
          />
          {errors.vet_email && (
            <p className="text-sm text-red-500">{errors.vet_email}</p>
          )}
        </div>
      </div>
    </div>
  );
}